import script from "./BaseFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFilter.vue?vue&type=script&setup=true&lang=js"

import "./BaseFilter.vue?vue&type=style&index=0&id=a577fabe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a577fabe"]])

export default __exports__